import React from 'react'
import Modal from 'react-modal';

function CustomModal({ title, children, showHeader = true, isOpen, setIsOpen, modalClassName = '', bodyClassName = '', overlayClassName = 'Overlay' }) {

    const closeModal = () => {
        setIsOpen(false)
    }

    return (
        <Modal
            closeTimeoutMS={500}
            isOpen={isOpen}
            onRequestClose={closeModal}
            className={`Modal${modalClassName ? ` ${modalClassName}` : ''}`}
            overlayClassName={overlayClassName}
        >
            <div className="modal-content">
                {showHeader && <div className="modal-header">
                    <button type="button" className="close" onClick={closeModal}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    {title && <h4 className="modal-title">{title}</h4>}
                </div>}
                <div className={`modal-body text-center${bodyClassName ? ` ${bodyClassName}` : ''}`}>
                    {children}
                </div>

            </div>
        </Modal>
    )
}

export default CustomModal